export const CN_DATETIME_UNITS = ["年", "季度", "月", "周", "日", "小时", "分钟", "秒", "毫秒", "微秒"]
export const CN_WEEK_DAYS = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
export const CN_SHORT_WEEK_DAYS = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]
export const CN_MONTH_NAMES = ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
export const CN_SHORT_MONTH_NAMES = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]

export const CN_NUMBER_DIGITS = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"]
export const CN_NUMBER_UNITS = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '兆', '十', '百', '千', '京', '十', '百', '千', '垓']
export const CN_NUMBER_BIG_DIGITS = ["零", '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
export const CN_NUMBER_BIG_UNITS = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟', '兆', '拾', '佰', '仟', '京', '拾', '佰', '仟', '垓']
